import { createUseStyles } from 'react-jss'

import { black, darkGrey, mediumGrey } from '../../../styles/const/colors'
import { scrollableList } from '../../../styles/common'
import { textEllipsisMultiline } from '../../../styles/mixins/text'

const useStyles = createUseStyles({
  list: {
    extend: scrollableList
  },
  attributionsTooltip: {
    marginLeft: 4
  },
  attributionsTooltipBody: {
    padding: '0 !important'
  },
  valueColumnWithTooltip: {
    display: 'flex',
    marginLeft: 'auto',
    justifyContent: 'flex-end'
  },
  nameLink: {
    color: black,
    textDecoration: 'none',
    ...textEllipsisMultiline(),
    lineBreak: 'anywhere',
    '&:hover': {
      color: darkGrey
    }
  },
  columnSubText: {
    color: mediumGrey,
    marginTop: 2,
    fontSize: 12
  },
  valueColumn: {
    textAlign: 'right'
  },
  resultName: {
    whiteSpace: 'normal'
  },
  statusChip: {
    marginRight: 0 // reset default margin for chip
  }
})

export default useStyles
